import { HStack } from "@gluestack-ui/themed";
import { Text } from "@repo/core/components/core/Text";
import { ConditionInfoProps } from "./types";

export const ConditionInfo = ({
  name,
  value,
  isGray = false,
  isBold
}: ConditionInfoProps) => {
  return (
    <HStack
      p="$2"
      w="$full"
      justifyContent="space-between"
      bg={isGray ? "$backgroundLight50" : "$backgroundLight0"}
    >
      <Text fontSize="$xs" fontWeight={isBold ? 600 : 400}>
        {name}
      </Text>
      <Text fontSize="$sm" fontWeight={isBold ? 600 : 500}>
        {value}
      </Text>
    </HStack>
  );
};
